import theme from '../../../theme/news12'

import css from 'styled-jsx/css'

export default css`
  button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: max-content;
    margin: 24px auto;
    padding: 11px 32px 9px;
    height: 50px;
    background-color: ${theme.colors.lightBlue};
    border: none;
    border-radius: 4px;
    font-family: Graphik;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    color: ${theme.colors.white};
  }
  
  button:hover {
    background: ${theme.colors.blueHover2};
    cursor: pointer;
  }
`
